import axios from './axiosConfig'

export const getMessage = async (page) => {
  try {
    const response = await axios.get(`/contactus?page=${page}`)
    // console.log('message:', response.data)
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const addMessage = async (id) => {
  try {
    const response = await axios.post(`/contactus/${id}`)
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const getFounder = async (page) => {
  try {
    const response = await axios.get(`/contactus/founder?page=${page}`)
    console.log('founder:', response.data)
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const getInvestor = async (page) => {
  try {
    const response = await axios.get(`/contactus/investor?page=${page}`)
    console.log('investor:', response.data)
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const getFounderById = async (id) => {
  try {
    const response = await axios.get(`/contactus/founder/${id}`)
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const updateFounder = async (data, id) => {
  try {
    const response = await axios.put(`/contactus/founder/${id}`, data)
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}
